import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useData } from "@/context/DataContext";
import { Reveal } from "@/components/shared/Reveal";

const HISTORY_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/i2khs6kh_Novemberka%CC%8Asan%202025-8.webp";

export const HistoryTeaser = () => {
  return (
    <section data-testid="history-teaser" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-white/10">
          <img src={HISTORY_IMG} alt="Novemberkåsans historia" className="absolute inset-0 h-full w-full object-cover grayscale" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/40" />
          <div className="relative z-10 px-6 sm:px-14 py-20 sm:py-28 max-w-2xl">
            <Reveal>
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-amber-500">Historia</span>
              <h2 className="mt-4 font-display text-4xl sm:text-6xl font-black uppercase tracking-tight text-white leading-[1.02]">
                Mer än ett sekel<br />av legender
              </h2>
              <p className="mt-5 text-lg text-white/70">
                Novemberkåsan har körts sedan 1915 och är en av världens äldsta endurotävlingar. Vinnarnas namn,
                de brutala åren och de omöjliga bragderna är en del av svensk motorsporthistoria.
              </p>
              <Link to="/historia" className="mt-8 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-amber-500 hover:gap-3 transition-all">
                Utforska historien <ArrowRight className="w-4 h-4" />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
